import { FieldProps } from 'formik';
import { DatePicker } from '@mui/x-date-pickers';
import { LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';

console.log('FormDatePicker', DatePicker);

export default function FormDatePicker({ form, field, label, ...props }: FieldProps & { label?: string }) {
    const error = form.touched[field.name] && Boolean(form.errors[field.name]);
    const helperText = (form.touched[field.name] && form.errors[field.name]) as string;

    return (
        <LocalizationProvider dateAdapter={AdapterDateFns}>
            <DatePicker
                label={label}
                value={field.value}
                onChange={date => {
                    form.setFieldValue(field.name, date);
                    form.setFieldTouched(field.name).catch(console.error);
                }}
                slotProps={{
                    textField: {
                        fullWidth: true,
                        error: error,
                        helperText: helperText,
                    },
                    field: {
                        clearable: true,
                        onClear: () => {
                            form.setFieldValue(field.name, null);
                            form.setFieldTouched(field.name).catch(console.error);
                        },
                    },
                }}
                {...props}
            />
        </LocalizationProvider>
    );
}
